"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var classnames_1 = __importDefault(require("classnames"));

var PromotionsCard = function (props) {
  var _a, _b;

  var bem = (0, hook_use_bem_classes_1.default)('rwc-promotions-card');
  var cols = (_a = props.columns) !== null && _a !== void 0 ? _a : '4';
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: bem()
  }, {
    children: (0, jsx_runtime_1.jsx)("div", __assign({
      className: bem('promotion-foreground')
    }, {
      children: (0, jsx_runtime_1.jsxs)("div", __assign({
        className: bem('promotion-card-container')
      }, {
        children: [(0, jsx_runtime_1.jsx)("h2", __assign({
          className: bem('promotion-card-container-title')
        }, {
          children: props.title
        })), (0, jsx_runtime_1.jsx)("div", __assign({
          className: bem('promotion-cards')
        }, {
          children: (_b = props.promotions) === null || _b === void 0 ? void 0 : _b.map(function (card) {
            return (0, jsx_runtime_1.jsxs)("div", __assign({
              className: (0, classnames_1.default)(bem('promotion-card'), bem('promotion-card', "".concat(cols, "-col")))
            }, {
              children: [(0, jsx_runtime_1.jsx)("h3", {
                children: card.title
              }), card.description]
            }), "".concat(card.title));
          })
        }))]
      }))
    }))
  }));
};

exports.default = PromotionsCard;